<template>
  <el-table
    :data="counties"
    max-height="250"
    style="width: 100%"
    v-loading="loading"
    :default-sort="{prop: 'name', order: 'ascending'}"
  >
    <el-table-column
      prop="name"
      label="Név"
    />
    <el-table-column
      fixed="right"
      label=""
      width="120"
    >
      <template slot-scope="scope">
        <Actions :county="scope.row" />
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
  import Actions from './Actions'

  export default {

    components: {
      Actions
    },

    computed: {
      counties() {
        return this.$store.getters['county/counties'];
      },

      loading() {
        return this.$store.getters['county/loading'];
      }
    },

    async mounted() {
      await this.$store.dispatch('county/fetchAll');
    },
  }
</script>
